import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectHostState = (state: RootState) => state.Host || initialState

export const hostSelector = createSelector([selectHostState], Host => Host)
